/*
 * @Author: jiangxd
 * @Date: 2021-08-04 11:24:02
 * @LastEditTime: 2021-08-04 11:44:27
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/views/components/shopDisplaySketchMap/displayEdit/hoverIcon.tsx
 */
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import MiniLinkSelect from "./linkSelect.vue";
import style from "./style.vue";
import { appEnvConfig } from "@/configs/appConfigs";
import { EmpServiceAPIActions } from "@/services/empService";
import baseAPIService from "@/services/base/baseAPIService";
import linkMiniPage from "@/views/components/linkForm/miniPage";
import { noop } from "@/util";
import { Functions } from "@/library/utils/functions";

enum HoverIconPage {
	WeiYeMian = 16,
	LianXiDaoGou = 4,
	QieHuanDianPu = 8,
	GouWuChe = 1,
	SHARE = 17,
}

const HoverIconDefault = [
	{
		value: HoverIconPage.WeiYeMian,
		label: "微页面",
		defaultImg: "https://ssl-picture.tenyun.runsasoft.com/shouye-weiyemian.png",
	},
	{
		value: HoverIconPage.LianXiDaoGou,
		label: "联系导购",
		defaultImg: "https://ssl-picture.tenyun.runsasoft.com/shouye-lianxidaogou.png",
	},
	{
		value: HoverIconPage.QieHuanDianPu,
		label: "切换店铺",
		defaultImg: "https://ssl-picture.tenyun.runsasoft.com/shouye-qiehuandianpu.png",
	},
	{ value: HoverIconPage.GouWuChe, label: "购物车", defaultImg: "https://ssl-picture.tenyun.runsasoft.com/shouye-gouwuche.png" },
	{ value: HoverIconPage.SHARE, label: "分享", defaultImg: "https://ssl-picture.tenyun.runsasoft.com/xuanfufenxiang.png" },
];

@Component({
	components: { "mini-link-select": MiniLinkSelect },
	mixins: [style],
})
export default class HoverIcon extends Vue {
	@Prop({ default: () => {} })
	value: DisplayHoverIconData;

	@Prop()
	disabled: boolean;

	data: DisplayHoverIconData = {};

	imgTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

	tokenData: ItemObject = {
		Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
	};

	isHover = true;

	@Watch("value", { deep: true, immediate: true })
	watchValue(n, o) {
		if (JSON.stringify(n) !== JSON.stringify(o)) {
			this.data = n;
		}
	}

	@Watch("data", { deep: true })
	watchData() {
		this.$emit("input", this.data);
	}

	handleDel(i) {
		this.data.desc.list.splice(i, 1);
	}

	addHoverIcon() {
		this.data.desc.list.push({
			title: "联系导购",
			url: "https://ssl-picture.tenyun.runsasoft.com/shouye-lianxidaogou.png",
			page: 4,
			pageId: "",
			pageName: "",
		});
	}

	keys = [1, 12, 23, 34, 45, 56];

	beforeUpload(file) {
		const isJPG = file.type === "image/jpeg";
		const isPNG = file.type === "image/png";
		const isGIF = file.type === "image/gif";
		const isLt1000KB = file.size / 1024 < 300;

		if (!isJPG && !isPNG && !isGIF) {
			this.$message.error("上传图片只支持 JPG/JPEG/PNG/GIF 格式!");
		}
		if (!isLt1000KB) {
			this.$message.error(`上传图片大小不能超过 ${300}KB!`);
		}
		return (isJPG || isPNG || isGIF) && isLt1000KB;
	}

	uploadSuccess(i, res: HttpAPIRetItem<any>) {
		this.data.desc.list[i].url = res.content;
	}

	onChangeHoverIcon(val, i) {
		this.data.desc.list[i].page = val;
		this.data.desc.list[i].url = HoverIconDefault.find((v) => v.value === val).defaultImg;
	}

	linkPage(index) {
		if (this.disabled) {
			return;
		}
		linkMiniPage.open({ sgId: Number(this.$route.params.id) }).then((result) => {
			this.data.desc.list[index].pageId = result.id;
			this.data.desc.list[index].pageName = result.name;
			this.$forceUpdate();
		}, noop);
	}

	render(h) {
		return this.data.desc ? (
			<div class="hover-icon-edit">
				<el-form ref="form" props={{ model: this.data }} disabled={this.disabled}>
					{this.data.desc && Array.isArray(this.data.desc.list) && (
						<draggable draggable=".hover-icon-item" disabled={!this.isHover || this.disabled} scroll={true} v-model={this.data.desc.list} scroll-sensitivity={150} force-fallback={true}>
							{this.data.desc.list.map((v, i) => {
								const defaultImg = HoverIconDefault.find((ho) => ho.value === v.page).defaultImg;
								return (
									<div class="hover-icon-item" key={v.url + v.page + i}>
										<div class="hover-icon-config">
											<div class="icon-img">
												<img src={v.url || defaultImg} alt="" class="img" />
												<el-upload
													action={this.imgTpConfig}
													headers={this.tokenData}
													before-upload={this.beforeUpload}
													maxSize={300}
													data={{ corpId: baseAPIService.resolveCorpId() }}
													{...{
														props: {
															"on-success": this.uploadSuccess.bind(this, i),
															"on-error": () => {
																this.$message.error("图片上传错误，请稍后重试！");
															},
														},
													}}
													show-file-list={false}>
													<span class="modify">修改</span>
												</el-upload>
											</div>
										</div>
										<div class="icon-config-info">
											<el-form-item label="图标名称" prop={`desc.list[${i}].title`} rules={[{ required: true, message: " ", trigger: "change" }]}>
												<el-input v-model={v.title} style="width: 60%"></el-input>
											</el-form-item>
											<div class="link-select">
												<div class="link-label">链接</div>
												<mini-link-select
													class="wid-60"
													value={v.page}
													hoverIconDefault={HoverIconDefault}
													onChange={(val) => this.onChangeHoverIcon(val, i)}
													onMouseenter={(val) => (this.isHover = val)}
													onMouseleave={(val) => (this.isHover = val)}
												/>
											</div>
											{v.page === HoverIconPage.WeiYeMian && (
												<el-form-item prop={`desc.list[${i}].pageName`} rules={[{ required: true, message: "请选择微页面", trigger: "change" }]} inline-message={true} show-message={!v.pageId} class="link-min-page">
													<span class={["scopeSpan mini-page-link", this.disabled && "disabled"]} title={v.pageName} onMouseenter={() => (this.isHover = false)} onMouseleave={() => (this.isHover = true)} onClick={this.linkPage.bind(this, i)}>
														{v.pageName || "请选择"}
													</span>
												</el-form-item>
											)}
										</div>
										{!this.disabled && <i class="el-icon-error redText delete" onClick={this.handleDel.bind(this, i)} onMouseenter={() => (this.isHover = false)} onMouseleave={() => (this.isHover = true)} />}
									</div>
								);
							})}
						</draggable>
					)}
					{this.data.desc.list.length < 5 && (
						<div class="hover-icon-item r-mt-10">
							<span class="text-decort" onClick={this.addHoverIcon.bind(this)}>
								+添加一个悬浮图标
							</span>
						</div>
					)}
				</el-form>
				<div class="tip">注: 多个图标支持拖动排序</div>
			</div>
		) : (
			""
		);
	}
}
